module.exports = __webpack_public_path__ + "fonts/MyriadPro-CondIt.5717a97.ttf";